/*
 * The office's contact details, shared by the footer (Footer.js) and the
 * contact page (Contact.js) so the two can't drift apart.
 *
 * Each line opens the matching app: tel: for the phone, wa.me for WhatsApp
 * (works on desktop and mobile), mailto: for email and Google Maps for the
 * office. `icon` is a Material UI icon component, rendered in place of the
 * old "T:" / "E:" labels. `external` links open in a new tab.
 *
 * The same phone, email and address also appear in structuredData.js (the
 * search-engine business listing) - update both if any of them change.
 */

import { Phone, WhatsApp, Email, Room } from "@material-ui/icons";

export const CONTACT_LINKS = [
    { icon: Phone, text: "020 8946 7171", href: "tel:+442089467171", label: "Call us on 020 8946 7171" },
    {
        icon: WhatsApp,
        text: "07380 118 118",
        href: "https://wa.me/447380118118",
        label: "Message us on WhatsApp on 07380 118 118",
        external: true,
    },
    { icon: Email, text: "info@property-people.co.uk", href: "mailto:info@property-people.co.uk" },
    {
        icon: Room,
        text: "204 Tooting High Street, London, SW17 0SG",
        href: "https://www.google.com/maps/search/?api=1&query=Property+People+204+Tooting+High+Street+London+SW17+0SG",
        label: "204 Tooting High Street, London, SW17 0SG (opens Google Maps)",
        external: true,
    },
];
